import React, { useState, lazy } from 'react';
import { ExpertProfile } from './expertsData';
import { User } from 'lucide-react';
import { CVRequestModal } from './CVRequestModal';
interface ExpertCardProps {
  expert: ExpertProfile;
}
export function ExpertCard({
  expert
}: ExpertCardProps) {
  const [showCVModal, setShowCVModal] = useState(false);
  return <>
      <div className="flex flex-col bg-white border border-[#E2E8F0] hover:border-teal-300 transition-colors duration-200 h-full group" data-id="element-148">
        <a href={`/experts/${expert.slug}`} className="p-6 flex-1 flex flex-col" data-id="element-149">
          {/* Headshot */}
          <div className="w-24 h-24 bg-warm-100 rounded-2xl overflow-hidden mb-5 flex-shrink-0" data-id="element-150">
            {expert.image ? <img src={expert.image} alt={`Professional headshot of ${expert.name}, ${expert.role} for UK medico-legal expert witness services`} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" loading="lazy" data-id="element-151" /> : <div className="w-full h-full flex items-center justify-center text-ink-300" data-id="element-152">
                <User className="w-8 h-8" data-id="element-153" />
              </div>}
          </div>

          {/* Name & Title */}
          <div className="mb-4" data-id="element-154">
            <h3 className="text-lg font-bold text-ink-900 leading-tight mb-1 group-hover:text-teal-700 transition-colors" data-id="element-155">
              {expert.name}
            </h3>
            <p className="text-sm font-semibold text-ink-700 mb-1.5" data-id="element-156">
              {expert.role}
            </p>
            <p className="text-xs text-ink-400 font-mono" role="img" aria-label={`Official General Medical Council registration badge indicating verified clinical status — GMC number ${expert.gmc}`} data-id="element-157">
              GMC: {expert.gmc}
            </p>
          </div>

          {/* Key Specialisms */}
          <div className="mt-auto" data-id="element-158">
            <ul className="space-y-1.5 mb-6" data-id="element-159">
              {expert.keySpecialisms.map((specialism, index) => <li key={index} className="flex items-start text-sm text-ink-600" data-id="element-160">
                  <span className="text-teal-500 mr-2 mt-0.5" data-id="element-161">•</span>
                  <span className="leading-snug" data-id="element-162">{specialism}</span>
                </li>)}
            </ul>
          </div>
        </a>

        {/* Footer CTAs */}
        <div className="p-6 pt-0 mt-auto flex gap-3" data-id="element-163">
          <a href={`/experts/${expert.slug}`} className="flex-1 inline-flex items-center justify-center px-4 py-2.5 text-sm font-semibold rounded-xl border border-[#E2E8F0] text-ink-600 hover:border-teal-500 hover:text-teal-600 transition-colors duration-200" data-id="element-164">
            View Profile
          </a>
          <button onClick={() => setShowCVModal(true)} className="flex-1 inline-flex items-center justify-center px-4 py-2.5 text-sm font-semibold rounded-xl border border-teal-500 text-teal-600 hover:bg-teal-50 transition-colors duration-200" data-id="element-165">
            Request CV
          </button>
        </div>
      </div>

      <CVRequestModal expertName={expert.name} expertRole={expert.role} isOpen={showCVModal} onClose={() => setShowCVModal(false)} data-id="element-166" />
    </>;
}